import { css } from 'styled-components';

const imageOverlayStyle = css`
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: ${({ theme }) => theme.ComponentsProductCardOverlay};
        pointer-events: none;
`;

export default imageOverlayStyle;
